import React, { useState, useEffect } from 'react';

import 'react-toastify/dist/ReactToastify.css';

import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { get } from 'lodash';
import { InputText } from 'primereact/inputtext';

import * as actions from '../../../store/modules/auth/actions';

import { displayErrors } from '../../../util/diversos';
import { Input155px } from '../../../styles/inputGroup';

import Card from '../../../components/card';
import store from '../../../store/store';
import axiosAdmin from '../../../services/axiosAdmin';
import Loading from '../../loading';

export default function CadastroVendedor({ payloadCadastro, childToParentConsulta }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const id = get(payloadCadastro, 'id', 0);
  const [nome, setNome] = useState('');
  const [codigo, setCodigo] = useState('');

  useEffect(() => {
    let newTitle = 'Vendedor - Cadastro';
    if (id) {
      newTitle = 'Vendedor - Edição';
    }

    dispatch(actions.titleHeaderChange({ newTitle }));

    if (!id) return;

    async function getData() {
      try {
        setIsLoading(true);

        const { data } = await axiosAdmin.get(`/vendedor/${id}`);

        const idUsuario = get(store.getState().auth.user, 'id', 0);

        if (data.idUsuario !== idUsuario) {
          navigate('/consultavendedor');
          toast.error('Acesso negado');
        }

        setNome(data.nome);
        setCodigo(data.codigo);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }

    getData();
  }, [dispatch, id, navigate]);

  async function salvarRegistro() {
    try {
      setIsLoading(true);

      const idUsuario = get(store.getState().auth.user, 'id', 0);

      const cnpjEmpresa = get(payloadCadastro, 'cnpjEmpresa', '');

      const shippingData = {
        idUsuario,
        cnpjEmpresa,
        nome,
        codigo,
      };

      let payloadDataTableList = {};

      if (id > 0) {
        payloadDataTableList = get(await axiosAdmin.put(`/vendedor/${id}`, shippingData), 'data', {});
        toast.success('Vendedor atualizado com sucesso');
      } else {
        payloadDataTableList = get(await axiosAdmin.post('/vendedor', shippingData), 'data', {});
        toast.success('Vendedor cadastrado com sucesso');
      }

      childToParentConsulta(payloadDataTableList, id);
    } catch (err) {
      displayErrors(err, dispatch, navigate, '', 'Não foi possível atualizar o registro');
    } finally {
      setIsLoading(false);
    }
  }

  const handleCancel = () => {
    childToParentConsulta();
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let formErros = false;

    if (!codigo) {
      formErros = true;
      toast.error('Código do vendedor deve ter informado');
    }

    if (nome.length < 3 || nome.length > 40) {
      formErros = true;
      toast.error('Nome do vendedor deve ter entre 3 a 50 caracteres');
    }

    if (formErros) return;

    salvarRegistro();
  };

  const titulo = () => (id ? 'Vendedor - Alteração' : 'Vendedor - Inclusão');

  return (
    <div>
      <Loading isLoading={isLoading} />
      <Card>
        <div className="card mb-3">
          <h6 className="card-header" style={{ textAlign: 'left', justifyContent: 'flex-start', width: '100%' }}>{titulo()}</h6>
        </div>
        <div className="row form-elo">
          <div className="col-4">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Código
              </Input155px>
              <InputText
                autoFocus
                maxLength={10}
                value={codigo}
                onChange={e => setCodigo(e.target.value)}
              />
            </div>
          </div>
          <div className="col-8">
            <div className="p-inputgroup">
              <Input155px className="p-inputgroup-addon">
                Nome
              </Input155px>
              <InputText
                maxLength={40}
                value={nome}
                onChange={e => setNome(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <button
              onClick={handleSubmit}
              type="button"
              className="btn btn-success"
            >
              <i className="pi pi-check"></i>
              Salvar
            </button>
            <button
              onClick={handleCancel}
              type="button"
              className="btn btn-danger"
            >
              <i className="pi pi-times"></i>
              Cancelar
            </button>
          </div>
        </div>
      </Card>
    </div>
  );
}

